import { render, staticRenderFns } from "./firstpage.vue?vue&type=template&id=912cf08a&scoped=true&"
import script from "./firstpage.vue?vue&type=script&lang=js&"
export * from "./firstpage.vue?vue&type=script&lang=js&"
import style0 from "./firstpage.vue?vue&type=style&index=0&id=912cf08a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912cf08a",
  null
  
)

export default component.exports